import React from 'react';

import { Trans } from '@lingui/react/macro';
import type { Theme } from '@mui/material';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { format } from 'date-fns';

import { colors } from '../../../../utils/theme';

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'end',
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  text: {
    fontSize: 14,
    fontStyle: 'italic',
    marginLeft: 'auto',
    color: colors.CAPTION,
  },
}));

interface Props {
  timeStamp: string;
}

const DATE_FORMAT = 'MM/dd/yyyy';

const RefreshTimeStamp = ({ timeStamp }: Props) => {
  const classes = useStyle();

  return (
    <div className={`${classes.root}`}>
      {timeStamp && (
        <Typography className={classes.text}>
          <Trans>
            Data last refreshed: {format(new Date(timeStamp), DATE_FORMAT)}
          </Trans>
        </Typography>
      )}
    </div>
  );
};

export default RefreshTimeStamp;
